import moment from "moment";
import api from "./api";

export default class API {

  static async getCustomers(query, body) {
    return api.request(`api/admin/get/customers?filter=${query}`, "POST", body);
  }
  
  static async getUsers(query, body) {
    return api.request(`api/admin/users/list?filter=${query}`, "POST", body);
  }
  
  static async updateUser(body) {
    return api.putRequest(`api/admin/update/user`, "PUT", body);
  }

  static async getUsersPermission() {
    return api.getRequest("api/user/permission", "GET");
  }


  static async getCustomersNoPagination(query, body) {
    return api.request(`api/admin/get/customers-no-pagination?filter=${query}`, "POST", body)
  }
  static async getRecentOrdersByCustomer(body) {
    return api.request("api/admin/get/order-by-customer", "POST", body);
  }

  static async getBrands(body) {
    return api.request(`api/brand/getBrand`, "POST", body);
  }

  static async getBrandById(brandId) {
    return api.getRequest(`api/brand/getBrand/${brandId}`, "GET");
  }

  static async searchBrands(body) {
    return api.request(`api/brand/searchBrandForAdmin`, "POST", body);
  }

  static async addBrands(body) {
    return api.request(`api/brand/addBrand`, "POST", body);
  }

  static async updateBrands(body) {
    return api.request(`api/brand/editBrand`, "POST", body);
  }

  static async getCountries(body) {
		return api.request(`api/admin/countries`, "POST", body);
	}

  static async getCategory(body) {
    return api.request("api/category/getAllStoreCategories", "POST", body);
  }

  static async getCategoryByID(body) {
    return api.request("api/category/getAllStoreCategoryById", "POST", body);
  }

  static async searchCategory(body) {
    return api.request("api/category/searchStoreCategories", "POST", body);
  }

  static async updatenableDisableCategory(body) {
    return api.request(`api/category/merchantUpdateItemRelatedAvailability`, "POST", body);
  }

  static async addCategory(body) {
    return api.request("api/category/addCategory", "POST", body);
  }

  static async updateCategory(body) {
    return api.request("api/category/editCategory", "POST", body);
  }

  static async updateCategoryOrder(body) {
    return api.request("api/category/UpdateCategoryOrder", "POST", body);
  } 

  static async reversedProduct(body) {
    return api.request("api/admin/product/reverseProduct","POST", body);
  }

  static async getSubCategory(body) {
    return api.request("api/category/getAllStoreSubCategories", "POST", body);
  }

  static async searchSubCategory(body) {
    return api.request("api/category/searchStoreSubCategories", "POST", body);
  }

  static async updatenableDisableSubCategory(body) {
    return api.request(`api/category/merchantUpdateItemRelatedAvailability`, "POST", body);
  }

  static async searchProductNew(body) {
    return api.request("v1/admin/get/menuitem", "POST", body);
  }

  static async searchProduct(body) {
    return api.request("api/admin/products/search", "POST", body);
  }

  static async addSubCategory(body) {
    return api.request("api/subCategory/addsubCategory", "POST", body);
  }


  static async updateSubCategory(body) {
    return api.request("api/subCategory/editSubCategory", "POST", body);
  }

  static async getProduct(body) {
    return api.request("v1/admin/get/menuitem", "POST", body);
  }
  static async getPromotionProducts(body) {
    return api.request("api/admin/getPromotionProducts", "POST", body);
  }
  static async searchPromoProductNew(body) {
    return api.request("api/admin/getPromotionProducts", "POST", body);
  }

  static async getSupplierProduct(body) {
    return api.request("api/admin/supplierProduct/list", "POST", body);
  }

  static async updateEnableDisableSupplierProduct(body) {
    return api.request("api/admin/supplierProduct/update", "POST", body);
  }

  static async getPromotionHistory(body) {
    return api.request("api/admin/supplierProduct/promotionHistory", "POST", body);
  }

  static async getPriceHistory(body) {
    return api.request("api/admin/product/priceHistory", "POST", body);
  }

  static async getWarehouseLocationsByWarehouseID(body) {
    return api.request("api/admin/warehouseLocation/getByWarehouse", "POST", body);
  }

  static async getWarehouse(body) {
    return api.request("api/admin/warehouse/list", "POST", body);
  }

  static async getWarehouseDetailByID(id) {
    return api.getRequest(`api/admin/warehouse/get/${id}`, "GET")
  }

  static async updateWarehouse(id, body){
    return api.request(`api/admin/warehouse/update/${id}`, "PATCH", body)
  }

  static async createWarehouse(body) {
    return api.request("api/admin/warehouse/create", "POST", body);
  }

  static async deleteWarehouse(id) {
    return await api.deleteRequest(`api/admin/warehouse/delete/${id}`, "DELETE");
  }

  static async getStockManagement(body) {
    return api.request("api/admin/stockManagement/list", "POST", body);
  }

	static async updateStockPerId(body) {
		return api.request("api/admin/stockManagement/update_per_stock_id", "POST", body);
	}

  static async uploadStockManagement(body) {
    return api.request("api/admin/stockManagement/upload", "POST", body);
  }

	static async addStockManagement(body) {
		return api.request("api/admin/stockManagement/add", "POST", body);
	}

  // ---- WMS (warehouse management system) ----
  // Product listing is at price-type (variant) grain: a product with several
  // variants returns one row per variant, each with its own price_type_id.
  static async getWmsProducts(body) {
    return api.request("api/wms/products", "POST", body);
  }

  // Weight is always sent in grams; the backend stores it with weight_unit 'g'.
  // Pass price_type_id to target a single variant, or item_id to update every
  // live variant of the product. The two ids are distinct sequences — sending
  // one where the other is expected silently writes to the wrong product.
  static async updateWmsProductWeight(body) {
    return api.request("api/wms/product/weight/update", "POST", body);
  }

  static async bulkUpdateWmsProductWeights(body) {
    return api.request("api/wms/product/weight/bulk-update", "POST", body);
  }

  static async updateWmsProductWeightBySku(body) {
    return api.request("api/wms/product/weight/update-by-sku", "POST", body);
  }

  static async updatenableDisableProduct(body) {
    return api.request("api/admin/product/enable", "POST", body);
  }

  static async quantityUpdateProduct(body) {
    return api.request("api/admin/product/changeQuantity", "POST", body);
  }

  static async getSuppliers(body) {
    return api.request("api/admin/suppliers", "POST", body);
  }

  static async addSupplier(body) {
    return api.request('api/admin/supplier/create', 'POST', body);
  }

  static async getSubCategoryMap(body) {
    return api.request("api/category/getAllSubCategoriesMappedCategory", "POST", body);
  }

  static async getCouponMapCategoriesStoreUsers(body) {
    return api.request("api/category/getMapCategoriesStoreUsers", "POST", body);
  }

  static async getCouponProduct(body) {
    return api.request("api/product/getCouponProduct", "POST", body);
  }

  static async getDefaultProduct() {
    return api.getRequest("api/product/getDefaultPrduct", "GET");
  }

  static async addProduct(body) {
    return api.request("api/admin/product/add", "POST", body);
  }

  static async updateProduct(body) {
    return api.request("api/admin/product/update", "POST", body);
  }

  static async updateProductImage(body) {
    return api.request("api/admin/product/updateImage", "POST", body);
  }

  static async deleteProduct(body) {
    return api.request("api/admin/product/delete", "POST", body);
  }

  static async getProductById(body) {
    return api.request("api/admin/product/get", "POST", body);
  }

  static async getOrders(body) {
    return api.request("api/cart/getBasicInfoOrders", "POST", body);
  }

  static async changeOrderStatus(body) {
    return api.request("api/cart/changeOrderStatusAdmin", "POST", body);
  }

  static async fatchOrder(body) {
	  return api.request("api/v2/cart/fetchOrder", "POST", body);
  }

	static async fetchOrderV2(orderId) {
		return api.getRequest(`v1/admin/orderDetail/${orderId}`, "GET");
	}

  static async updateDeliveryType(body) {
    return api.putRequest(`v1/admin/updateDeliveryType`, "PUT", body);
  }

  static async getOrdersListsBySupplier(body) {
    return api.request("api/admin/supplier/orders", "POST", body);
  }

  static async updateSupplierCredential(body) {
    return api.request("api/admin/supplier/update/credential", "POST", body);
  }

  // `type` selects normal (0, the default) or express (1); `delivery_type`
  // narrows to one fulfilment mode; `is_active` narrows to enabled or disabled
  // rules. Omitting `type` does not mean "both" — the API falls back to 0 — so
  // callers wanting every order type must request each one. Called with no args
  // it behaves exactly as before, so existing callers are unaffected.
  static async getAllDeliveryRule(params) {
    const query = new URLSearchParams();
    if (params?.type !== undefined && params.type !== '') query.set('type', params.type);
    if (params?.delivery_type) query.set('delivery_type', params.delivery_type);
    if (params?.is_active !== undefined && params.is_active !== '') {
      query.set('is_active', params.is_active);
    }
    const suffix = query.toString() ? `?${query.toString()}` : '';
    return api.getRequest(`v1/admin/get/all/deliveryrule${suffix}`, "GET");
  }

  static async getDeliveryRuleDetail(id) {
    return api.getRequest(`v1/admin/get/deliveryrule/detail/${id}`, "GET");
  }

  // The matrix is built by ADDING rows — a weight-bounded rule, or a pickup
  // rule for the same distance band — not by editing the existing ones.
  static async createDeliveryRule(body) {
    return api.request(`v1/admin/create/deliveryrule`, "POST", body);
  }

  // Hard delete. The API refuses to remove the last rule for an order type,
  // since that would leave orders with no rule at all.
  static async deleteDeliveryRuleById(id) {
    return api.deleteRequest(`v1/admin/delete/deliveryrule/${id}`, "DELETE");
  }

	static async getNormalDeliverySettingHistory(params) {
		return api.getRequest(
			`v1/admin/deliveryrule/history/${params.page ?? 1}/${
				params.limit ?? 5
			}/${params.id}`,
			"GET"
		);
	}

  static async getExpressDeliverySettingHistory(params) {
    return api.getRequest(
			`v1/admin/express/deliveryrule/history/${params.page ?? 1}/${
				params.limit ?? 5
			}/${params.id}`,
			"GET"
		);
  }

  static async updateDeliveryRuleById({param, body}) {
    return api.putRequest(`v1/admin/update/deliveryrule/${param}`, "PUT", body);
  }

// Shop Setting
  static async getShopSetting() {
    return api.getRequest(`v1/admin/get/shop/setting`, "GET");
  }

  static async getItemsListsByOrder(body) {
    return api.request("api/admin/supplier/order/items", "POST", body);
  }

  static async getItemsOrdersListsBySupplier(body) {
    return api.request("v1/admin/get/supplier/order", "POST", body);
  }

  static async updateSupplierItemStatus(body) {
    return api.request("api/admin/supplier/update/item", "POST", body);
  }

  static async getSuppliersLists(query, body) {
    return api.request(`api/admin/supplier/list?filter=${query.selectedStatus}&search=${query.search}`, "POST", body);
  }

  static async markOrderAs(body) {
    return api.request("api/admin/supplier/orders/mark-order-as", "POST", body);
  }

  static async exportOrders(body) {
    return api.request("api/admin/supplier/orders/export", "POST", body);
  }

  static async changeBulkOrderStatus(body) {
    return api.request("api/cart/changeBulkOrderStatusAdmin", "POST", body);
  }

  static async createPickupFile(body) {
    return api.request("v3/api/admin/makePickupFile", "POST", body);
  }

  static async generateInvoice(body) {
    return api.request("api/payment/sendEmails", "POST", body);
  }

  static async resendPaymentReport(body) {
    return api.request("api/resend/payment-report", "POST", body);
  }

	// V2: Resend invoice with updated items (includes cancelled/replaced items)
	static async resendPaymentReportV2(body) {
		return api.request("api/v2/resend/payment-report", "POST", body);
	}

  static async generateBulkInvoice(body) {
    return api.request("api/payment/sendBulkEmails", "POST", body);
  }

	static async resendBulkInvoice(body) {
		return api.request("api/v2/resend/bulk/payment-report", "POST", body);
	}

  static async productExtract(body) {
    return api.request("api/v2/admin/product/extract/all", "POST", body);
  }
  
  static async promotionExtract(body) {
    return api.request("api/admin/promotion/extract/all", "POST", body);
  }

  static async orderReport(body) {
    return api.request("api/admin/order/extract", "POST", body);
  }

  static async updateCatBanner(body) {
    return api.request("api/category/updateCatBanner", "POST", body);
  }

  static async updateSubCatBanner(body) {
    return api.request("api/subCategory/updateSubCatBanner", "POST", body);
  }

  static async updateHomepageBanner(body) {
    return api.request("api/admin/update/hamepageBanner", "POST", body);
  }

  static async updateBanner(body) {
    return api.request("api/admin/banner/update", "POST", body);
  }

  static async updateCheckoutBanner(body) {
    return api.request("api/admin/update/checkoutBanner", "POST", body);
  }

  static async getBannerImages(body) {
    return api.request("api/admin/get/banner", "POST", body);
  }

  static async changeExpressStatus(body) {
    return api.request("v1/admin/shop/update", "POST", body);
  }

  static async getProductByID(body){
    return api.request("api/product/getProductInfo", "POST", body)
  }

// Express Setting
  static async getExpressSetting() {
    return api.getRequest(`v1/admin/get/express/setting`, "GET");
  }

  static async updateExpressSetting(body) {
    return api.putRequest(`v1/admin/update/express/setting`, "PUT", body);
  }

/*
   *   ===================== Coupon ===================
   * */
  static async getAllCoupons(params, queries) {
    return await api.getRequest(`v1/admin/couponCode/${params.next}/${params.limit}?${queries}`, "GET");
  }

  static async createCoupon(body) {
    return await api.request(`v1/admin/couponCode`, "POST", body);
  }

  static async removeCoupon(id) {
    return await api.deleteRequest(`v1/admin/couponCode/${id}`, "DELETE");
  }

  static async updateCoupon(body) {
    return await api.putRequest(`v1/admin/couponCode`, "PUT", body);
  }

  static async getCouponUsage(couponId) {
    return await api.getRequest(`v1/admin/get/user/usage/coupon/${couponId}`, "GET");
  }

	// Lookup coupon by code (for manual entry)
	static async lookupCouponByCode(code) {
		return await api.getRequest(`v1/admin/coupon/lookup-by-code?code=${encodeURIComponent(code)}`, "GET");
	}

  // picker user to coupon
  static async pickerUserToCoupon(body) {
    return await api.request(`v1/admin/PickUserToCouponCode`, "POST" , body);
  }

  //search customer
  static async SearchCustomerPickToCouponCode(body) {
    return await api.request(`v1/admin/SearchCustomerPickToCouponCode`, "POST" , body);
  }

  //get user pick coupon code
  static async getCustomerPickCouponCodeByCode(body) {
    return await api.request(`v1/admin/getCustomerPickCouponCodeByCode`, "POST" , body);
  }

  //remove user from coupon code
  static async RemoveCustomerPickCouponCodeByCode(body) {
    return await api.request(`v1/admin/RemoveCustomerPickCouponCodeByCode`, "POST" , body);
  }

  static async getAllCustomerPickCouponCode(body) {
    return await api.request(`v1/admin/getAllCustomerPickCouponCode`, "POST" , body);
  }

  static async generateCouponCode(body) {
    return await api.request(`v1/admin/generateCouponCode`, "POST" , body);
  }

  static async createCouponCodeTemplate(body) {
    return await api.request(`v1/admin/createCustomerLinkedCouponTemplate`, "POST" , body);
  }

  static async getAllCouponTemplate(body) {
    let query = "";
    if(body && body.type){
      query = `type=${body?.type}`;
    }
    if(body && body.search){
      query += `&search=${body?.search}`;
    }
    return await api.request(`v1/coupons/getAllCouponTemplate?${query}`, "POST" , body);
  }

  static async createCouponFromTemplate(body) {
    return await api.request(`v1/coupons/createCouponFromTemplate`, "POST" , body);
  }

  static async createCouponToCustomerFromTemplate(body) {
    return await api.request(`v1/coupons/createCouponToCustomerFromTemplate`, "POST" , body);
  }
  /*
   *   ===================== End coupon ===================
   * */

// Shop Setting
  static async getShopSetting() {
    return api.getRequest(`v1/admin/get/shop/setting`, "GET");
  }

  static async updateShopSetting(body) {
    return api.putRequest(`v1/admin/update/shop/setting`, "PUT", body);
  }

// Auth
  static async supplierResetPasswordRequest(body) {
    return api.request("api/changeMerchantPasswordRequest", "POST", body);
  }

  static async updateSupplierPassword(body) {
    return api.request("api/changeMerchantPassword", "POST", body);
  }

//  Order API
  static async getOrderListPagination(
      params
  ) {
    let query = `statusList=${params.statusList}`;
    if (params.type === "0" || params.type === "1") {
      query += `&type=${params.type}`
    }

    if (params && params.search) {
      query += `&search=${params.search}`
    }

    if (params && params.startDate) {
      query += `&startDate=${params.startDate}`
    }

    if (params && params.endDate) {
      query += `&endDate=${params.endDate}`
    }

    if (params && params.dateFilter) {
      query += `&dateFilter=${params.dateFilter}`
    }

    if (params && params.orderField) {
      query += `&orderField=${params.orderField}`
    }

    if (params && params.orderType) {
      query += `&orderType=${params.orderType}`
    }

	  if (params && params.specialFilter) {
		  query += `&specialFilter=${params.specialFilter}`
	  }

	  if (params && params.provinceFilter) {
		  query += `&provinceFilter=${params.provinceFilter}`
	  }

    if (params && params.sourceFilter) {
      query += `&sourceFilter=${params.sourceFilter}`
    }

    return api.getRequest(`v1/admin/get/order/list/${params.next}/${params.limit}?${query}`, "GET");
  }

  static async getOrderListWithoutPagination(
      params
  ) {
    let query = `statusList=${params.statusList}`;
    if (params.type === "0" || params.type === "1") {
      query += `&type=${params.type}`
    }

    if (params && params.search) {
      query += `&search=${params.search}`
    }

    if (params && params.startDate) {
      query += `&startDate=${params.startDate}`
    } else if (params && params.startDateDefault) {
      query += `&startDate=${params.startDateDefault}`
    }

    if (params && params.endDate) {
      query += `&endDate=${params.endDate}`
    } else if (params && params.endDateDefault) {
      query += `&endDate=${params.endDateDefault}`
    }

    if (params && params.dateFilter) {
      query += `&dateFilter=${params.dateFilter}`
    }

    if (params && params.orderField) {
      query += `&orderField=${params.orderField}`
    }

    if (params && params.orderType) {
      query += `&orderType=${params.orderType}`
    }

	  if (params && params.specialFilter) {
		  query += `&specialFilter=${params.specialFilter}`
	  }

	  if (params && params.provinceFilter) {
		  query += `&provinceFilter=${params.provinceFilter}`
	  }

    if (params && params.sourceFilter) {
      query += `&sourceFilter=${params.sourceFilter}`
    }

    return api.getRequest(`v1/admin/get/order/list?${query}`, "GET");
  }

  static async getProductNeverOrderWithoutPagination() {
    return api.getRequest(`v1/admin/get/product/order/track`, "GET");
  }

  static async updateOrder(params, body) {
    return api.putRequest(`v1/admin/update/order/${params.orderId}`, "PUT", body, null);
  }

	static async getOrderDetails(orderId) {
		const response = await api.getRequest(`api/orders/${orderId}`, "GET");
		return response.json();
	}

	static async updateOrderItems(orderId, body) {
		const response = await api.putRequest(`api/orders/${orderId}`, "PUT", body);
		return response.json();
	}

	static async recalculateOrder(orderId, body) {
		const response = await api.request(`api/orders/${orderId}/recalculate`, "POST", body);
		return response.json();
	}

	static async cancelOrderAdmin(orderId) {
		const response = await api.request(`api/orders/${orderId}/cancel`, "POST");
		return response.json();
	}

	static async searchProducts(body) {
		const response = await api.request("api/admin/products/search", "POST", body);
		return response.json();
	}

	static async replaceOrderItem(orderId, itemId, body) {
		const response = await api.request(`api/orders/${orderId}/items/${itemId}/replace`, "POST", body);
		return response.json();
	}

	static async restoreOrderItem(orderId, itemId) {
		const response = await api.request(`api/orders/${orderId}/items/${itemId}/restore`, "POST");
		return response.json();
	}

	static async deleteOrderItem(orderId, itemId) {
		const response = await api.request(`api/orders/${orderId}/items/${itemId}`, "DELETE");
		return response.json();
	}

	static async addOrderItem(orderId, body) {
		const response = await api.request(`api/orders/${orderId}/items`, "POST", body);
		return response.json();
	}

	static async updateDriverTip(orderId, body) {
		const response = await api.request(`api/orders/${orderId}/driver-tip`, "PUT", body);
		return response.json();
	}

	static async updateDeliveryFee(orderId, body) {
		const response = await api.request(`api/orders/${orderId}/delivery-fee`, "PUT", body);
		return response.json();
	}

  static async addSecondaryDriver(params, body) {
    return api.putRequest(`v1/admin/addSecondaryDriver/order/${params.orderId}`, "PUT", body, null);
  }

  static async removeSecondaryDriver(params, body) {
    return api.request(`v1/admin/removeSecondaryDriver/order/${params.orderId}`, "POST", body, null);
  }

  static async getOrderStatusCount(params = {}) {
    let query = '';
    if (params.startDate) query += `startDate=${params.startDate}`;
    if (params.endDate) query += `${query ? '&' : ''}endDate=${params.endDate}`;
    return api.getRequest(`v1/admin/get/status/count${query ? '?' + query : ''}`, "GET");
  }

  static async getOrderBasicList(params) {
    let query = `statusList=${params.statusList}&fromDate=${params.fromDate}`;
    if(params.fromDate && params.timeOptions?.minStart && params.timeOptions?.maxEnd){
      const minStart = moment(`${params.fromDate} ${params.timeOptions.minStart}`).format('YYYY-MM-DD HH:mm');
      const maxEnd = moment(`${params.fromDate} ${params.timeOptions.maxEnd}`).format('YYYY-MM-DD HH:mm');

      query += `&minStart=${minStart}&maxEnd=${maxEnd}`
    }
    return api.getRequest(`v1/admin/order/basic/list?${query}`)
  }

  static async getOrderDetailByOrderId(body) {
	  return api.request(`api/v2/cart/fetchOrder`, "POST", body)
  }

  static async queryOrder(body) {
    return api.request(`api/payment/queryOrder`, "POST", body)
  }

  static async approveOrder(body) {
    return api.request(`api/payment/approveOrder`, "POST", body)
  }

  static async updateSlot(body) {
    return api.putRequest(`api/payment/updateSlot`, "PUT", body)
  }
  
  static async updateOutTradeNo(data) {
    return api.putRequest(`api/payment/outtradeno/${data}`, "PUT", null)
  }
  
// Customer API
  static async updateCustomerEnableExpress(body) {
    return api.putRequest(`v1/admin/user/enableexpress`, "PUT", body, null);
  }

  static async updateCustomer(body) {
    return api.putRequest(`v1/admin/user`, "PUT", body);
  }

  static async deleteCustomer(body) {
    return api.request(`v1/admin/delete/user`, "DELETE", body);
  }

// Driver API
  static async getDriverList(params) {
	  let url = `v1/admin/get/driver/list/${params.next}/${params.limit}?showDisabled=${params.showType}`;
	  if (params.search) {
		  url += `&search=${encodeURIComponent(params.search)}`;
	  }
	  return api.getRequest(url, "GET");
  }

  static async getInActiveDriverList(params) {
    return api.getRequest(`v1/admin/get/driver/list/${params.next}/${params.limit}?showDisabled=${params.showDisabled}`, "GET");
  }

  static async createDriver(body) {
    return api.request(`v1/admin/create/driver`, "POST", body);
  }

  static async updateDriver(driverId, body) {
    return api.putRequest(`v1/admin/update/driver/${driverId}`, "PUT", body, null);
  }

// Wallet
  static async getWalletTransactionByCustomerId(params) {
    return api.getRequest(`v1/admin/get/wallet/transaction/customerId/${params.customerId}/${params.next}/${params.limit}`, "GET");
  }

  static async addWalletTransaction(body) {
    return api.request(`v1/admin/wallet/transfer`, "POST", body);
  }

	static async updateWalletTransaction(transactionId, body) {
		return api.request(`v1/admin/wallet/transaction/${transactionId}`, "PUT", body);
	}

// Basket
  static async sendCustomPushToClient(userId, body) {
    return api.request(`v1/admin/send/custom/push/${userId}`, "POST", body);
  }

// Slider
  static async getSliderList(params, query) {
    let queryString = `is_deleted=${query.isDeleted}&type=${query.type}`;
    if (query.isActive) {
      queryString += `&is_active=${query.isActive}`
    }
    if(query.search) {
      queryString += `&search=${query.search}`;
    }
    return api.getRequest(`v1/admin/offerslide/${params.next}/${params.limit}?${queryString}`, "GET");
  }

  static async updateSlide(params, body) {
    return api.putRequest(`v1/admin/offerslide/${params.slider_id}`, "PUT", body);
  }

  static async createSlide(body) {
    return api.request(`v1/admin/offerslide`, "POST", body);
  }

// Address
  static async UpdateAddress(addressId, body) {
    return api.putRequest(`v1/admin/address/customer/${addressId}`, "PUT", body);
  }

	static async CreateAddress(custId, body) {
		return api.request(`v1/admin/address/customer/${custId}`, "POST", body);
	}

	static async DeleteAddress(addressId) {
		return api.deleteRequest(`v1/admin/address/customer/${addressId}`, "DELETE");
	}

	static async getCustomerAddresses(custId) {
		return api.getRequest(`v1/admin/address/customer/${custId}`, "GET");
	}

	static async updateOrderAddress(orderId, addressId) {
		return api.request(`v1/admin/order/${orderId}/address`, "PUT", {address_id: addressId});
	}

// Supplier API
  static async getSupplierOrderBySupplierId(body) {
    return api.request(`v1/admin/express/get/supplier/order`, "POST", body);
  }

  static async getExpressStore(body) {
    return api.request(`v1/admin/express/get/stores`, "POST", body);
  }

  static async updateExpressSequence(body) {
    return api.request(`v1/admin/express/store/update-sequence`, "POST", body);
  }

  static async uploadPromotion(body) {
    return api.request(`api/admin/product/promotion`, "POST", body);
  }

  //notification 
  static async pushNotification(body) {
    return api.request('api/admin/notifications/push', "POST", body)
  }

  static async getRegisteredFcmUsers(body) {
    return api.request(`api/admin/getRegisteredFcmUsers`, "POST", body);
  }

  static async getAllNotifications(body) {
    return api.request(`api/admin/notifications/getAll`, "POST", body);
  }

  static async getScheduleNotifications() {
    return api.getRequest(`api/admin/notifications/schedule?_locale=en`, "GET");
  }

  static async cancelScheduleNotification(id) {
    return api.deleteRequest(`api/admin/notifications/schedule/${id}`, "DELETE");
  }

  static async toSendNotification(id) {
    return api.request(`api/admin/notifications/send/${id}`, "POST");
  }

  static async updateScheduleNotification(id, body) {
    return api.putRequest(`api/admin/notifications/schedule/${id}`, "PUT", body);
  }

  // Related Products
  static async addRelatedProduct(body) {
    return api.request(`api/relatedProducts/add`, "POST", body);
  }
  static async removeRelatedProduct(query) {
    return api.putRequest(`api/relatedProducts/remove?product_id=${query.product_id}&related_id=${query.related_id}`, "PUT");
  }
  static async getRelatedProduct(query) {
    return api.getRequest(`api/relatedProducts/get?product_id=${query.product_id}&limit=${query.limit}&page=${query.page}`, "GET");
  }
  
  //nav menu

  //type
  static async getTypes(params, query) {
    let queryString = `is_deleted=${query.isDeleted}&type=${query.type}`;
    if (query.isActive) {
      queryString += `&is_active=${query.isActive}`
    }
    return api.getRequest(`api/admin/types/${params.next}/${params.limit}?${queryString}`, "GET");
  }

  static async updateTypes(params, body) {
    return api.putRequest(`api/admin/types/${params.id}`, "PUT", body);
  }

  static async createTypes(body) {
    return api.request(`api/admin/types`, "POST", body);
  }

  //typeCat
  static async getTypesCats(params, query) {
    let queryString = `is_deleted=${query.isDeleted}&type=${query.type}`;
    if (query.isActive) {
      queryString += `&is_active=${query.isActive}`
    }
    return api.getRequest(`api/admin/types/${params.type_id}/cats/${params.next}/${params.limit}?${queryString}`, "GET");
  }

  static async getCatsForTypes() {
    return api.getRequest('api/admin/types/cats', "GET");
  }
 
  static async updateTypesCats(params, body) {
    return api.putRequest(`api/admin/types/cats/${params.id}`, "PUT", body);
  }

  static async deleteTypesCats(params) {
    return api.deleteRequest(`api/admin/types/cats/${params.id}`, "DELETE");
  }

  static async createTypesCats(params, body) {
    return api.request(`api/admin/types/${params.type_id}/cats`, "POST", body);
  }
  
  // type sub cats
  static async getSubCatsType(catId, page, limit) {
    return api.getRequest(`api/admin/types/cats/sub-cats/${catId}/${page}/${limit}`, "GET");
  }

  static async updateSubCatsTypeSequence(body) {
    return api.putRequest(`api/admin/types/cats/sub-cats/update-sequence`, "PUT", body);
  }

  //Homepage Management 
  static async getAdminProductOfTheWeek(body) {
    return api.request("api/admin/productOfTheWeek/get", "POST", body);
  }
  static async updateAdminProductOfTheWeek (body){
    return api.request('api/admin/productOfTheWeek/update', "POST", body)
  }

  static async getShopByCats(params, query) {
    let queryString = `is_deleted=${query.isDeleted}&type=${query.type}`;
    if (query.isActive) {
      queryString += `&is_active=${query.isActive}`
    }
    return api.getRequest(`api/admin/shopByCats/${params.next}/${params.limit}?${queryString}`, "GET");
  }

  static async updateShopByCats(params, body) {
    return api.putRequest(`api/admin/shopByCats/${params.id}`, "PUT", body);
  }

  static async createShopByCats(body) {
    return api.request(`api/admin/shopByCats`, "POST", body);
  }
  static async createVideoHomePage(body) {
    return api.request(`api/createVideoHomePage`, "POST", body);
  }
  static async AdminGetAllVideoHomePage(params,body) {
    return api.request(`api/AdminGetAllVideoHomePage/${params.next}/${params.limit}`, "POST", body);
  }
  static async getAllVideoHomePage(body) {
    return api.request(`api/getAllVideoHomePage`, "POST", body);
  }
  static async UpdateVideoHomePageIsActive(params, body) {
    return api.request(`api/UpdateVideoHomePageIsActive/${params.id}`, "POST", body);
  }
  static async UpdateVideoHomePage(params, body) {
    return api.request(`api/updateVideoHomePage/${params.id}`, "POST", body);
  }


  static async getSelectionBanners(params, query) {
    let queryString = `is_deleted=${query.isDeleted}&type=${query.type}`;
    if (query.isActive) {
      queryString += `&is_active=${query.isActive}`
    }
    return api.getRequest(`api/admin/selectionBanners/${params.next}/${params.limit}?${queryString}`, "GET");
  }

  static async updateSelectionBanners(params, body) {
    return api.putRequest(`api/admin/selectionBanners/${params.id}`, "PUT", body);
  }

  static async createSelectionBanners(body) {
    return api.request(`api/admin/selectionBanners`, "POST", body);
  }

  static async getBottomBanners(params, query) {
    let queryString = ``;
    if (query.isActive) {
      queryString += `&is_active=${query.isActive}`
    }
    return api.getRequest(`api/admin/bottomBanners/${params.next}/${params.limit}?${queryString}`, "GET");
  }
  static async updateBottomBanners(params, body) {
    return api.putRequest(`api/admin/bottomBanners/${params.id}`, "PUT", body);
  }
  static async createBottomBanners(body) {
    return api.request(`api/admin/bottomBanners`, "POST", body);
  }

  // Sale Promotion Campaigns
  static async getAllAdminSaleCampaigns(query){
    return api.getRequest(`api/v1/admin/campaign/get?active=${query?.active ?? ""}&status=${query?.status ?? ""}`, "GET")
  }
  static async createdAminSaleCampaign(body){
    return api.request(`api/v1/admin/campaign/create`, "POST", body)
  }
  static async updateAdminSaleCampaign(body){
    return api.request(`api/v1/admin/campaign/update`, "PATCH", body)
  }
  static async deleteAdminSaleCampaign(query){
    return api.request(`api/v1/admin/campaign/delete?campaign_id=${query.campaign_id}`, "DELETE",)
  }
  static async getAdminProductsSaleCampaign(query){
    return api.getRequest(`api/v1/admin/campaign/products/get?campaign_id=${query?.campaign_id}&search=${query.search ?? ""}&page=${query.page ?? 0}&limit=${query.limit ?? 0}`, "GET");
  }
  static async createAdminProductsSaleCampaign(body){
    return api.request(`api/v1/admin/campaign/products/create?`, "POST", body);
  }
  static async addAdminProductsSaleCampaign(body){
    return api.request(`api/v1/admin/campaign/products/add?`, "POST", body);
  }
  static async updateAdminProductsSaleCampaign(body){
    return api.putRequest(`api/v1/admin/campaign/products/update`, "PUT", body);
  }
  static async deleteAdminProductsSaleCampaign(body){
    return api.request(`api/v1/admin/campaign/products/delete`, "DELETE", body);
  }

  static async getReviewCard(params,query) {
    let queryString = ``;
    if (query.is_active) {
      queryString += `&is_active=${query.is_active}`
    }
    return api.request(`api/admin/getAllReviewCard/${params.next}/${params.limit}?${queryString}`, "POST");
  }
  static async AddReviewCard(body) {
    return api.request('api/admin/createReviewCard', "POST", body);
  }
  static async UpdateReviewCard(body) {
    return api.request('api/admin/UpdateReviewCard', "PUT", body);
  }

  // App Versions
  static async getAllAdminAppVersion(body){
    return api.request(`api/v1/admin/getAllAppVersions`, "POST", body);
  }
  static async createAdminNewAppVersion(body){
    return api.request(`api/v1/admin/newAppVersion`, "POST", body);
  }
  static async updateAdminAppVersion(body){
    return api.request(`api/v1/admin/updateAppVersion`, "PATCH", body);
  }
  static async deleteAdminAppVersion(query){
    return api.request(`api/v1/admin/deleteAppVersion?appId=${query?.appId}`, "DELETE");
  }

  // Admin Analytics
  static async getOrdersAnalytic(query){
    return api.getRequest(`api/v1/admin/analytic/orders?year=${query.year}`, "GET");
  }
  static async getRevenueAnalytic(query){
    return api.getRequest(`api/v1/admin/analytic/revenue?year=${query.year}`, "GET");
  }
  static async getCustomersAnalytic(query){
    return api.getRequest(`api/v1/admin/analytic/customers?year=${query.year}`, "GET");
  }
  static async getOverviewsAnalytic(query){
    return api.getRequest(`api/v1/admin/analytic/overviews?year=${query.year}`, "GET");
  }
  static async getTopSellingProductsAnalytic(query){
    let queryString = Object.keys(query).reduce((acc, key) => {
      return acc += `${key}=${query[key]}&`;
    }, '');
    return api.getRequest(`api/v1/admin/analytic/best-sellers?${queryString}`, "GET");
  }

  // Generate Payment Link
  static async generatePaymentLink(body){
    return api.request(`api/payment/generatePaymentLink`, "POST", body);
  }
  static async getGeneratedPaymentLinks(query){
    let { page = 0, limit = 0, search = "", orderDate } = query;
    let querySearch = page > 0 && limit > 0 ? `page=${page}&limit=${limit}` : "";
    querySearch += search ? `&search=${search}` : "";
    querySearch += orderDate ? `&orderDate=${orderDate}` : "";
    return api.getRequest(`api/payment/getGeneratedPaymentLinks?${querySearch}`, "GET");
  }

  // store logo
	static async getAdminStoreLogos(query) {
		let queryString = Object.keys(query)?.reduce((acc, curr) => {
			acc += `${curr}=${query[curr]}&`;
			return acc;
		}, "");

		return api.getRequest(`api/v1/admin/store-logo?${queryString}`, "GET");
	}

	static async createAdminStoreLogo(body) {
		return api.request(`api/v1/admin/store-logo`, "POST", body);
	}

	static async updateAdminStoreLogo(body) {
		return api.putRequest(`api/v1/admin/store-logo/${body.id}`, "PUT", body);
	}

	static async deleteAdminStoreLogo(body) {
		return api.deleteRequest(`api/v1/admin/store-logo/${body.id}`, "DELETE");
	}
  
  static async AdminUpdatePrimaryAddress(body, query) {
    return api.request(`api/admin/address/update?_locale=en&orderType=${query.orderType}`, "POST", body);
  }

  //recent search global search
  static async getGlobalStoreKeyword(body) {
    return api.request(`v1/admin/get/popular-search/${body.page}/${body.limit}`, "POST", body);
  }
  static async createGlobalStoreKeyword(body) {
    return api.request(`v1/admin/create/popular-search`, "POST", body);
  }
  static async updateGlobalStoreKeyword(body) {
    return api.putRequest(`v1/admin/update/popular-search/${body.id}`, "PUT", body);
  }
  static async deleteGlobalStoreKeyword(id) {
    return api.deleteRequest(`v1/admin/delete/popular-search/${id}`, "DELETE");
  }
  static async enableDisableGlobalStoreKeyword(body) {
    return api.putRequest(`v1/admin/enable-disable/popular-search/${body.id}`, "PUT", body);
  }

  static async updateOrderGlobalStoreKeyword(body) {
    return api.putRequest(`v1/admin/order/popular-search`, "PUT", body);
  }

  // 
  static async updateSlotAndDeliveryAtByAdmin(body) {
    return api.putRequest(`v1/admin/update/timeslot/${body.order_id}`, "PUT", body)
  }
  static async getUpdateSlotAndDeliveryAt(body) {
    return api.getRequest(`v1/admin/get/timeSlot/${body.page}/${body.limit}/${body.order_id}`, "GET")
  }

  static async getIsExistsProductCode(body) {
    return api.request(`api/product/check_product_sku`, "POST", body);
  }

  // merchant API
  static async getOngoingSlot(body) {
    return api.request(`api/onGoingSlot/getAllStoreOngoingSlots`, "POST", body);
  }

	static async adminGetAllSlotsDeliveryV2(body) {
		return api.request(`v2/admin/slot/getSlotDates`, "POST", body);
	}
  static async createOngoingSlot(body) {
    return api.request(`api/onGoingSlot/create`, "POST", body);
  }
  static async deleteOngoingSlot(body) {
    return api.request(`api/onGoingSlot/deleteV2`, "POST", body);
  }
  static async updateOngoingSlot(body) {
    return api.request(`api/onGoingSlot/edit`, "POST", body);
  }
  static async getAllSlotsByDate(body) {
    return api.request(`api/onGoingSlot/getAllSlotsByDate`, "POST", body);
  }
  static async stopAcceptOrder(body) {
    return api.request(`api/onGoingSlot/stopAcceptOrder`, "POST", body);
  }

  //slot settings
  static async getSlotSettings(body) {
    return api.request(`api/slot/AdminGetSlotSettings`, "POST", body);
  }
  static async createSlotSettings(body) {
    return api.request(`api/slot/AdminCreate`, "POST", body);
  }
  static async updateSlotSettings(body) {
    return api.request(`api/slot/edit`, "POST", body);
  }
  static async updateSlotSettingsOnOff(body) {
    return api.request(`api/slot/updateStoreOnOff`, "POST", body);
  }
  static async AdminDeleteSlotSettings(body) {
    return api.request(`api/slot/AdminDeleteSlotSettings`, "POST", body);
  }

  //merchant supplier picker
  static async createMapSupplierAndPicker(body) {
    return api.request(`api/picker/supplier/create`, "POST", body);
  }
  static async getAllMappedSupplierPicker(body) {
    return api.request(`api/v2/picker/supplier/getAll/${body.page}/${body.limit}`, "POST", body);
  }
  static async getAllSupplier(body) {
    return api.request(`api/picker/getAllSupplier`, "POST", body);
  }

  static async getAllDriverList(body) {
    return api.request(`api/picker/get/driver`, "POST", body);
  }

  static async updateMapSupplierAndPicker(body) {
    return api.request(`api/picker/updateMapSupplierAndPicker`, "POST", body);
  }

  static async markAttendance(body) {
    return api.request(`api/picker/markAttendance`, "POST", body);
  }
  
  // mail(sender.net)
  static async getSenderSubscribers(page = 1) {
    return api.getRequest(`api/admin/mail/list/subscribers?page=${page}`, "GET");
  }

  static async showSenderSubscriber(email) {
    return api.getRequest(`api/admin/mail/subscribers/${email}`, "GET");
  }

  static async getSenderFields() {
    return api.getRequest("api/admin/mail/getField", "GET");
  }

   //
  static async adminGetCustomerMailSubscribe(mail) {
    return api.getRequest(`api/v1/mail/subscriber/${mail}`, "GET");
  }

  static async AdminUpdateMailSubscribe(mail,body) {
    return api.putRequest(`api/v1/mail/subscriber/${mail}`, "PUT",body);
  }

  static async createSubscribers(body) {
    return api.request('api/admin/mail/subscriber/create', "POST", body)
  }

  static async updateSubscribers(body) {
    return api.request(`api/admin/mail/subscriber/${body.email}`, "PATCH", body)
  }

  //product selection api
  static async adminSetupProductsSelection(body) {
    return api.request(`api/v1/admin/products-selection-admin`, "POST", body);
  }

  static async adminUpdateProductsSelection(id,body) {
    return api.putRequest(`api/v1/admin/products-selection-admin/${id}`, "PUT", body);
  }

  static async adminGetProductsSelectionById(id) {
    return api.getRequest(`api/v1/admin/products-selection-admin/get/${id}`, "GET");
  }

  static async adminGetProductsSelection(page_type, page, limit, search,filter) {
    return api.getRequest(`api/v1/admin/products-selection-admin/type/${page_type}?page=${page}&limit=${limit}&search=${search}&filters=${filter}`, "GET");
  }

  static async adminDeletePagesSelection(page_id) {
    return api.deleteRequest(`api/v1/admin/products-selection-admin/page/${page_id}`, "DELETE");
  }

  static async adminUpdatePagesStatus(page_id,status,body) {
    return api.putRequest(`api/v1/admin/products-selection-admin/page-status/${page_id}/${status}`, "PUT" , body);
  }

	static async findTrackingCode(trackingCode, {orderId, courierCompany, getType, custId}) {
		return api.getRequest(`api/v1/cp/tracking-shipment?trackingCode=${trackingCode}&orderId=${orderId}&courierCompany=${courierCompany}&type=${getType}&custId=${custId}`, "GET");
	}

  static async getAdminSupplierProductBySupplierId(body) {
    return api.request('api/admin/supplier_product_by_supplier_id', "POST", body)
  }

	static async adminAddressGeoCod({lat, lng, placeId}) {
		let endpoint = ``;
		if (placeId) {
			endpoint = `v1/admin/address/geocode?placeId=${placeId}`
		} else {
			endpoint = `v1/admin/address/geocode?lat=${lat}&lng=${lng}`
		}
		return api.getRequest(endpoint, "GET");
	}

  // In API.js
	static async getDriverListFiltered(listAll, driverId = [], deliveryAt = null, start_time, end_time) {
		const queryParams = new URLSearchParams();

		queryParams.append("listAll", listAll);


    if (Array.isArray(driverId)) {
      driverId.forEach((id) => {
        if (id) queryParams.append("driverId", id);
      });
    } else if (driverId) {
      queryParams.append("driverId", driverId);
    }

    if (deliveryAt) {
      queryParams.append("deliveryAt", deliveryAt);
    }


    return await api.getRequest(
      `v1/admin/get/driver/position/list?${queryParams.toString()}`,
      "GET"
    );
  }

	static async adminGetDriverLocation() {
		return api.getRequest(`v1/admin/get/driver/position/list`, "GET");
	}

	static async deleteTrackingCode(trackingCode, orderId) {
		return api.deleteRequest(`api/v1/cp/tracking-shipment/${trackingCode}?orderId=${orderId}`, "DELETE");
	}

	static async getAllCourierCompany() {
    return api.getRequest(`api/v1/cp/shipment-tracking/shipment-type-list`);
  }
  static async createUpdateCourierCompany(body) {
    return api.putRequest(`v1/admin/updateCourierCompany`, "PUT", body);
  }

  static async createOrderShipmentPackage(body) {
    return api.putRequest(`v1/admin/createOrderShipmentPackage`, "PUT", body);
  }

	static async createOrderPaymentNoted(body) {
		return api.request(`api/order-payment-noted`, "POST", body);
	}

	static async updateOrderPaymentNoted(id, body) {
		return api.putRequest(`api/order-payment-noted/${id}`, "PUT", body);
	}

	static async deleteOrderPaymentNoted(id) {
		return api.deleteRequest(`api/order-payment-noted/${id}`, "DELETE");
	}
	static async getDietaryPreferencesList(params = {}) {
		const query = new URLSearchParams(params).toString();
		return api.getRequest(`api/dietary_preferences?${query}`, "GET");
	}

	static async addDietaryPreference(body) {
		return api.request(`api/dietary_preferences/add`, "POST", body);
	}

	static async updateDietaryPreference(id, body) {
		return api.putRequest(`api/dietary_preferences/${id}`, "PUT", body);
	}

	static async deleteDietaryPreference(id) {
		return api.deleteRequest(`api/dietary_preferences/${id}`, "DELETE");
	}

	// KESS Payment Link API
	static async getKessPaymentMethods() {
		// Use v3/webpay/gateway with service parameter to get payment methods
		return api.request(`v3/webpay/gateway?type=web`, "POST", {
			service: 'webpay.acquire.getPaymentMethods'
		});
	}

	static async getDelipoints(id) {
		return api.getRequest(`api/v1/delipoints/tiers/${id}`, "GET");
	}

	static async getDelipointTiersList(params = {}) {
		const query = new URLSearchParams(params).toString();
		return api.getRequest(`api/v1/delipoints/tiers/list?${query}`, "GET");
	}

	static async addDelipointTier(body) {
		return api.request(`api/v1/delipoints/tiers/add`, "POST", body);
	}

	static async updateDelipointTier(body) {
		return api.request(`api/v1/delipoints/tiers/update`, "PUT", body);
	}

	static async deleteDelipointTier(id) {
		return api.request(`api/v1/delipoints/tiers/${id}`, "DELETE");
	}

	static async getDelipointSettingsList(params = {}) {
		const query = new URLSearchParams(params).toString();
		return api.getRequest(`api/v1/delipoints/setting/list?${query}`, "GET");
	}

	static async updateDelipointSetting(body) {
		return api.request(`api/v1/delipoints/setting/update`, "PUT", body);
	}

	static async getDelipointPromotionsList(params = {}) {
		const query = new URLSearchParams(params).toString();
		return api.getRequest(`api/v1/delipoints/promotions/list?${query}`, "GET");
	}

	static async addDelipointPromotion(body) {
		return api.request(`api/v1/delipoints/promotions/add`, "POST", body);
	}

	static async updateDelipointPromotion(body) {
		return api.request(`api/v1/delipoints/promotions/update`, "PUT", body);
	}

	static async deleteDelipointPromotion(id) {
		return api.request(`api/v1/delipoints/promotions/${id}`, "DELETE");
	}

	static async getCustomerDelipointTransaction(body) {
		return api.request(`api/v1/admin/delipoints/customer/transactions`, "POST", body);
	}

	static async getCustomerDelipointCurrent(params = {}) {
		const query = new URLSearchParams(params).toString();
		return api.getRequest(`api/v1/admin/delipoints/customer/current?${query}`, "GET");
	}

	static async updateOrderPromotionDetails(body) {
		return api.putRequest(`api/v1/admin/delipoints/order-promotion-details`, "PUT", body);
	}

	static async evaluateCustomerTier(body) {
		return api.request(`api/v1/admin/delipoints/evaluate-customer-tier`, "POST", body);
	}

	static async getOrderPendingDelipointsTransactions(params = {}) {
		const query = new URLSearchParams(params).toString();
		return api.getRequest(`api/v1/admin/delipoints/order-pending-transactions?${query}`, "GET");
	}

	static async approvePendingDelipointsTransaction(body) {
		return api.putRequest(`api/v1/admin/delipoints/pending-transaction/approve`, "PUT", body);
	}

	static async queryKessPaymentByTradeNo(body) {
		return api.request(`api/kess-payment/query-by-trade-no`, "POST", body);
	}

	static async linkExistingKessPayment(body) {
		return api.request(`api/kess-payment/link-existing`, "POST", body);
	}

	static async linkManualKessPayment(body) {
		return api.request(`api/kess-payment/link-manual`, "POST", body);
	}

	static async updateKessPaymentLink(id, body) {
		return api.request(`api/kess-payment/update-link/${id}`, "PATCH", body);
	}

	static async uploadImage(formData) {
		return api.request(`api/product/uploadImage`, "POST", formData);
	}

	// ===== Dev Support (developer / customer-support tools) =====
	static async devSupportPushTelegram(orderId, body) {
		return api.request(`v1/admin/dev-support/order/${orderId}/push-telegram`, "POST", body);
	}

	static async devSupportApproveOrder(orderId, body) {
		return api.request(`v1/admin/dev-support/order/${orderId}/approve`, "POST", body);
	}

	static async devSupportQueryKess(body) {
		return api.request(`v1/admin/dev-support/payment/query-kess`, "POST", body);
	}

	static async devSupportQueryAba(orderId, body) {
		return api.request(`v1/admin/dev-support/order/${orderId}/query-aba`, "POST", body);
	}

	static async devSupportMarkPaid(orderId) {
		return api.request(`v1/admin/dev-support/order/${orderId}/mark-paid`, "POST", {});
	}

	static async devSupportUpdateOrder(orderId, body) {
		return api.request(`v1/admin/dev-support/order/${orderId}`, "PATCH", body);
	}

	static async devSupportUpdateOrderPayment(orderId, body) {
		return api.request(`v1/admin/dev-support/order/${orderId}/payment`, "PATCH", body);
	}

	static async devSupportHardDeleteOrderItems(body) {
		return api.request(`v1/admin/dev-support/order-items`, "DELETE", body);
	}

	static async devSupportGetOrderPayments(orderId) {
		return api.getRequest(`v1/admin/dev-support/order/${orderId}/payments`, "GET");
	}

	static async devSupportGetWallets(custId) {
		return api.getRequest(`v1/admin/dev-support/wallet/customer/${custId}`, "GET");
	}

	static async devSupportDeleteWallet(id, body) {
		return api.request(`v1/admin/dev-support/wallet/${id}`, "DELETE", body);
	}

	static async devSupportGetPaymentNoteds(orderId) {
		return api.getRequest(`v1/admin/dev-support/order/${orderId}/payment-noteds`, "GET");
	}

	static async devSupportDeletePaymentNoted(id, body) {
		return api.request(`v1/admin/dev-support/payment-noted/${id}`, "DELETE", body);
	}

	static async devSupportGetPaymentLinks(orderId) {
		return api.getRequest(`v1/admin/dev-support/order/${orderId}/payment-links`, "GET");
	}

	static async devSupportDeletePaymentLink(id, body) {
		return api.request(`v1/admin/dev-support/payment-link/${id}`, "DELETE", body);
	}

	static async devSupportGetWalletTransactions(ownerId) {
		return api.getRequest(`v1/admin/dev-support/wallet/transactions/owner/${ownerId}`, "GET");
	}

	static async devSupportDeleteWalletTransaction(id, body) {
		return api.request(`v1/admin/dev-support/wallet-transaction/${id}`, "DELETE", body);
	}

	static async devSupportHardDeleteOrderPayment(orderId, body) {
		return api.request(`v1/admin/dev-support/order/${orderId}/payment`, "DELETE", body);
	}

	// Delivery Companies
	static async getDeliveryCompaniesList(body = {}) {
		return api.request(`api/admin/delivery-companies`, "POST", body);
	}

	static async addDeliveryCompany(body) {
		return api.request(`api/admin/delivery-company/add`, "POST", body);
	}

	static async updateDeliveryCompany(body) {
		return api.request(`api/admin/delivery-company/update`, "POST", body);
	}

	static async deleteDeliveryCompany(body) {
		return api.request(`api/admin/delivery-company/delete`, "POST", body);
	}

	// Pickup Points
	static async getPickupPointsList(body = {}) {
		return api.request(`api/admin/pickup-points`, "POST", body);
	}

	static async addPickupPoint(body) {
		return api.request(`api/admin/pickup-point/add`, "POST", body);
	}

	static async updatePickupPoint(body) {
		return api.request(`api/admin/pickup-point/update`, "POST", body);
	}

	static async deletePickupPoint(body) {
		return api.request(`api/admin/pickup-point/delete`, "POST", body);
	}

}